"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavePersonDataResponseApiDomain = exports.SavePersonDataResponseDataApiDomain = exports.SavePersonDataRequestApiDomain = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const service_api_1 = require("../../service/service-api");
const api_domain_1 = require("../common/api-domain");
const updated_attributes_1 = require("../common/types/updated-attributes");
const utils_1 = require("../../utils");
// =============================================================================
// Request
// =============================================================================
class SavePersonDataRequestApiDomain extends service_api_1.ServiceRequestBodyApiDomain {
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
exports.SavePersonDataRequestApiDomain = SavePersonDataRequestApiDomain;
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsIn)(Object.values(updated_attributes_1.UpdatedAttributes), { each: true }),
    __metadata("design:type", Array)
], SavePersonDataRequestApiDomain.prototype, "updatedAttributeGroups", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SavePersonDataRequestApiDomain.prototype, "includeChildren", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SavePersonDataRequestApiDomain.prototype, "includeDeceased", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, utils_1.Is)({
        condition: (_, args) => {
            const object = args.object;
            if (object.withOsAppOnboardDate) {
                return !object.withAppOnboardDate;
            }
            return true;
        },
        message: "should only have either `withAppOnboardDate` or `withOsAppOnboardDate`",
    }),
    __metadata("design:type", Boolean)
], SavePersonDataRequestApiDomain.prototype, "withAppOnboardDate", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, utils_1.Is)({
        condition: (_, args) => {
            const object = args.object;
            if (object.withAppOnboardDate) {
                return !object.withOsAppOnboardDate;
            }
            return true;
        },
        message: "should only have either `withAppOnboardDate` or `withOsAppOnboardDate`",
    }),
    __metadata("design:type", Boolean)
], SavePersonDataRequestApiDomain.prototype, "withOsAppOnboardDate", void 0);
// =============================================================================
// Response
// =============================================================================
class SavePersonDataResponseDataApiDomain extends api_domain_1.GetPersonDataBase {
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
exports.SavePersonDataResponseDataApiDomain = SavePersonDataResponseDataApiDomain;
class SavePersonDataResponseApiDomain extends service_api_1.ServiceResponseBodyApiDomain {
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
exports.SavePersonDataResponseApiDomain = SavePersonDataResponseApiDomain;
__decorate([
    (0, class_transformer_1.Type)(() => SavePersonDataResponseDataApiDomain),
    __metadata("design:type", SavePersonDataResponseDataApiDomain)
], SavePersonDataResponseApiDomain.prototype, "data", void 0);
//# sourceMappingURL=save-person-data-api-domain.js.map